import React from "react";
import { Card } from "react-bootstrap";
import DegreeInformationTableView from "./DegreeInformationTableView";

interface DegreeInformationViewProps
{
    data: DegreeInformation;
}

export default class DegreeInformationView extends React.Component<DegreeInformationViewProps>
{
    render(): React.ReactNode
    {
        return <div>
            <h2>Academic</h2>
            {
                (this.props.data.ultimateDegrees && this.props.data.ultimateDegrees.length > 0)
                    ?
                    this.props.data.ultimateDegrees.map((degree: UltimateDegrees, i) =>
                    {
                        return <Card key={i} className={"border mb-2"}>
                            <div className={"m-3"}>
                                <DegreeInformationTableView data={degree} />
                            </div>
                        </Card>;
                    })
                    :
                    <Card className={"border mb-2"}>
                        <div className="m-3 text-center">
                            <br />
                            <p className="error-text">No Academic data available</p>
                        </div>
                    </Card>
            }
        </div>;
    }
}